import React from "react";
import parser from "html-react-parser";
import stringHelpers from "../helpers/stringHelpers";

const Heading = ({
  alignTitle,
  hTitleLevel,
  hTitleSeparator,
  title,
  subtitle,
  subtitleLevel,
  withinContainer,
}) => {
  const headingLevel = hTitleLevel ?? "h2";
  const hTitleAlign = alignTitle ?? "left";

  return withinContainer ? (
    <div className={"grid-container"}>
      {parser(
        stringHelpers.hTag(title, headingLevel, hTitleSeparator, hTitleAlign)
      )}
      {subtitle && parser(stringHelpers.hTag(subtitle, subtitleLevel))}
    </div>
  ) : (
    <>
      {parser(
        stringHelpers.hTag(title, headingLevel, hTitleSeparator, hTitleAlign)
      )}
      {subtitle && parser(stringHelpers.hTag(subtitle, subtitleLevel))}
    </>
  );
};

export default Heading;
